// extracted by mini-css-extract-plugin
export var card = "addresses-module--card--77028";
export var container = "addresses-module--container--40af4";
export var header = "addresses-module--header--d5a5e";
export var headerText = "addresses-module--header-text--0c1d7";
export var list = "addresses-module--list--38059";